import { useState } from "react";
import { Header } from "../../../components/Landing/Header/haeder.view";
import { HeaderScc } from "../../../components/Landing/Header/headerScc";
import { BreadCrumb } from "../../../components/Landing/Breadcrumb/breadcrumb.view";
import { Footer } from "../../../components/Landing/Footer";
import { Table, Button, Modal } from "antd";
import { ReactComponent as EyeIcon } from "../../../assets/eye-detail.svg";
import lepHome from "../../../assets/lep-home.png";
import lepRecursos from "../../../assets/recursos lep.png";
import { CarouselLEP } from "../components/Carousel/CarouselLEP";

export const Lep = () => {

  const [visualizasdocument, setVisualizarDocument] = useState<boolean>(false);
  const [url, setUrl] = useState<string>('');

  const visualizarModal = (url) => {
    setUrl(url)
    setVisualizarDocument(true);
  }

  const lep2021 = [
    { codigo: '2888', nombre: 'Estímulos a la circulación local en la Feria de Flores', url: 'https://drive.google.com/file/d/1maIbrFwa1auCeO-obfUedhcb3z5RbQYk/preview' },
    { codigo: '2949', nombre: 'Estímulos a la circulación nacional en artes escénicas', url: 'https://drive.google.com/file/d/1f64eTF_mg8Xe8OLwFoMyMcRj-zUDp_UP/preview' },
    { codigo: '2949', nombre: 'Estímulos a la circulación departamental en artes escénicas', url: 'https://drive.google.com/file/d/1wnri1x9MK6_Y93qkzsNJfacDnoejUBSg/preview' },
    { codigo: '2949', nombre: 'Estímulo para residencia artística en artes escénicas: El Salado - Carmen de Bolívar', url: 'https://drive.google.com/file/d/195xKM0b2cVnjVn9dBFcO2eGLQeuHrJia/preview' },
    { codigo: '2949', nombre: 'Estímulos a la circulación local de las artes escénicas - Músicas populares y tradicionales. Homenaje a la Retreta Dominical en el Parque de Bolívar', url: 'https://drive.google.com/file/d/1YBTFTXAOfL75pr0xikOoTKwAqpjjVTMc/preview' },
    { codigo: '2949', nombre: 'Estímulos a la circulación local de las artes escénicas - Medellín vive las artes', url: 'https://drive.google.com/file/d/1OntSlcP1r3AnklojL6tGgpLOVLlKXKL9/preview' },
    { codigo: '2950', nombre: 'Estímulo a la creación en artes escénicas: Visibilización y reconocimiento de los símbolos de la población LGTBIQ+ de Medellín a través de las artes escénicas', url: 'https://drive.google.com/file/d/1St33aqU59IUHcAtQwfbsQJmyW6zg4tvm/preview' },
    { codigo: '2950', nombre: 'Estímulo a la creación en artes escénicas: Familias diversas - Una puesta en escena para el reconocimiento y la visibilización de las familias de la población LGTBIQ+ de Medellín', url: 'https://drive.google.com/file/d/1xM-U8nRGqOXD16T5hsnLGhAZBv9tMW58/preview' },
    { codigo: '2950', nombre: 'Estímulos a la creación en artes escénicas integradas', url: 'https://drive.google.com/file/d/1BtrnGSASau070h6QMKtc5c5uJrX34dM6/preview' },
    { codigo: '2954', nombre: 'Estímulos para la formación, en continuidad a procesos del año anterior', url: 'https://drive.google.com/file/d/1224S2ynLqXq4dDaS9R7xvmg42MKNFr8w/preview' },
    { codigo: '2954', nombre: 'Estímulos en gestión del conocimiento para fortalecimiento del sector de las artes escénicas', url: 'https://drive.google.com/file/d/10KGJ5-PsAM3JOTX-ONRmcRoiuRX7cv1V/preview' },
    { codigo: '2954', nombre: 'Estímulos en formación artística para el fortalecimiento de procesos culturales comunitarios', url: 'https://drive.google.com/file/d/17w0UJiDa1GqgU9nn3YJLeTNss5ZRU5e5/preview' },
    { codigo: '2954', nombre: 'Estímulo a la formación en artes escénicas: Arte drag/transformista. Para el fortalecimiento de colectivos de con enfoque poblacional', url: 'https://drive.google.com/file/d/1zYo7Tkx8YO7C_CLdLck_6FG7NAipYOK7/preview' },
    { codigo: '2954', nombre: 'Estímulo a la formación en artes escénicas: Afro', url: 'https://drive.google.com/file/d/11pT6oKwfBYJ0wPTQSMaKYTmwO5G9W53w/preview' },
    { codigo: '2954', nombre: 'Estímulos a la gestión del conocimiento para el fortalecimiento de las artes escénicas- seminario Cu4tro.Creo', url: 'https://drive.google.com/file/d/1ugCCf1EVCUz81ML_CurY_R1Gdum6zm_Y/preview' },
    { codigo: '2953', nombre: 'Estímulos a la Producción de Eventos - Medellín Territorio Cultural', url: 'https://drive.google.com/file/d/14COEfWiwo3GFpivTcZ7_gARkC17Agr7k/preview' },
    { codigo: '2955', nombre: 'Estímulo para el fortalecimiento de espacios de exhibición para las artes escénicas', url: 'https://drive.google.com/file/d/1jENIs-aSFdsvP7hwrVq0Fdd7T_GRYU5s/preview' },
    { codigo: '2955', nombre: 'Estímulos para el fortalecimiento de entidades sin espacios de exhibición', url: 'https://drive.google.com/file/d/1JnkNmKM0ED_lB3zBUEmKUMTvz5ZYiMku/preview' },
    { codigo: '2955', nombre: 'Estímulo para el fortalecimiento de grupos sin espacios de exhibición', url: 'https://drive.google.com/file/d/1AkOltFEGXEaaUg-9LMjcs7vJTQH-6q1F/preview' },
    { codigo: '2956', nombre: 'Estímulos a la circulación local de las artes escénicas - Medellín vive las artes', url: 'https://drive.google.com/file/d/1OntSlcP1r3AnklojL6tGgpLOVLlKXKL9/preview' },
  ];

  const lep2022 = [
    { codigo: '3075', nombre: 'Estímulo a la producción de un evento con enfoque poblacional Afro', url: 'https://drive.google.com/file/d/19Zy-GKZ0KQOp8QKqoZrZA6-p1y-zykdb/preview' },
    { codigo: '3069', nombre: 'Estímulos a la producción de temporadas de estreno de espectáculos de las artes escénicas', url: 'https://drive.google.com/file/d/1V50vUoYYtI9rakfL36OQuCx0Ay_TshAj/preview' },
    { codigo: '3066', nombre: 'Estímulos a la producción de temporadas de estreno de espectáculos de las artes escénicas', url: 'https://drive.google.com/file/d/1V50vUoYYtI9rakfL36OQuCx0Ay_TshAj/preview' },
    { codigo: '3071', nombre: 'Estímulos a la producción de temporadas de estreno de espectáculos de las artes escénicas', url: 'https://drive.google.com/file/d/1V50vUoYYtI9rakfL36OQuCx0Ay_TshAj/preview' },
    { codigo: '3074', nombre: 'Estímulos a la producción de temporadas de estreno de espectáculos de las artes escénicas', url: 'https://drive.google.com/file/d/1V50vUoYYtI9rakfL36OQuCx0Ay_TshAj/preview' },
    { codigo: '3065', nombre: 'Estímulos a la producción de temporadas de estreno de espectáculos de las artes escénicas', url: 'https://drive.google.com/file/d/1V50vUoYYtI9rakfL36OQuCx0Ay_TshAj/preview' },
    { codigo: '3077', nombre: 'Estímulos a la producción de eventos de corta duración en artes escénicas', url: 'https://drive.google.com/file/d/15Wk6sy2GoofZO8CBUHyf1bEDqL_6S0uB/preview' },
    { codigo: '3076', nombre: 'Estímulos a la producción de eventos de corta duración en artes escénicas', url: 'https://drive.google.com/file/d/15Wk6sy2GoofZO8CBUHyf1bEDqL_6S0uB/preview' },
    { codigo: '3080', nombre: 'Estímulos a la producción de eventos de corta duración en artes escénicas', url: 'https://drive.google.com/file/d/15Wk6sy2GoofZO8CBUHyf1bEDqL_6S0uB/preview' },
    { codigo: '3081', nombre: 'Estímulo a la producción de una temporada de circo en la ciudad de Medellín', url: 'https://drive.google.com/file/d/15mEAS3Izl-clHtQ7Mt6MS9RGsCk7aFUH/preview' },
    { codigo: '3072', nombre: 'Estímulos a la producción de un festival de teatro infantil', url: 'https://drive.google.com/file/d/14WfDb5JPQVeIW4jmrvYXUU-bxZNjpFu0/preview' },
    { codigo: '3064', nombre: 'Estímulo a la producción de un festival de títeres', url: 'https://drive.google.com/file/d/1Jck1SeEGZ5H5A7JVrE6TmjeYuZuUzFFv/preview' },
    { codigo: '3155', nombre: 'Estímulos a la circulación local de artistas emergentes de las artes escénicas', url: 'https://drive.google.com/file/d/1rxeBtCjlSzSSoodDW4wecwRIpCwWR7HM/preview' },
    { codigo: '3153', nombre: 'Estímulos a la circulación local de artistas emergentes de las artes escénicas', url: 'https://drive.google.com/file/d/1rxeBtCjlSzSSoodDW4wecwRIpCwWR7HM/preview' },
    { codigo: '3156', nombre: 'Estímulos a la circulación local de artistas emergentes de las artes escénicas', url: 'https://drive.google.com/file/d/1rxeBtCjlSzSSoodDW4wecwRIpCwWR7HM/preview' },
    { codigo: '3154', nombre: 'Estímulos a la circulación local de artistas emergentes de las artes escénicas', url: 'https://drive.google.com/file/d/1rxeBtCjlSzSSoodDW4wecwRIpCwWR7HM/preview' },
    { codigo: '3162', nombre: 'Estímulos a la Circulación local de artes escénicas en los corregimientos de Medellín', url: 'https://drive.google.com/file/d/16QaIkJ5rE5L05ghCBiDfA6WjQVtS3UF_/preview' },
    { codigo: '3163', nombre: 'Estímulos a la Circulación local de artes escénicas en los corregimientos de Medellín', url: 'https://drive.google.com/file/d/16QaIkJ5rE5L05ghCBiDfA6WjQVtS3UF_/preview' },
    { codigo: '3164', nombre: 'Estímulos a la Circulación local de artes escénicas en los corregimientos de Medellín', url: 'https://drive.google.com/file/d/16QaIkJ5rE5L05ghCBiDfA6WjQVtS3UF_/preview' },
    { codigo: '3165', nombre: 'Estímulos a la Circulación local de artes escénicas en los corregimientos de Medellín', url: 'https://drive.google.com/file/d/16QaIkJ5rE5L05ghCBiDfA6WjQVtS3UF_/preview' },
    { codigo: '3166', nombre: 'Estímulos a la Circulación local de artes escénicas en los corregimientos de Medellín', url: 'https://drive.google.com/file/d/16QaIkJ5rE5L05ghCBiDfA6WjQVtS3UF_/preview' },
    { codigo: '3157', nombre: 'Estímulos para el circuito de grupos o entidades sin espacios de exhibición', url: 'https://drive.google.com/file/d/1ZLn8NSoNU7DMslU_fMwWxtrkYtFawGO0/preview' },
    { codigo: '3158', nombre: 'Estímulos para el circuito de grupos o entidades sin espacios de exhibición', url: 'https://drive.google.com/file/d/1ZLn8NSoNU7DMslU_fMwWxtrkYtFawGO0/preview' },
    { codigo: '3159', nombre: 'Estímulos para el circuito de grupos o entidades sin espacios de exhibición', url: 'https://drive.google.com/file/d/1ZLn8NSoNU7DMslU_fMwWxtrkYtFawGO0/preview' },
    { codigo: '3160', nombre: 'Estímulos para el circuito de grupos o entidades sin espacios de exhibición', url: 'https://drive.google.com/file/d/1ZLn8NSoNU7DMslU_fMwWxtrkYtFawGO0/preview' },
    { codigo: '3161', nombre: 'Estímulos para el circuito de grupos o entidades sin espacios de exhibición', url: 'https://drive.google.com/file/d/1ZLn8NSoNU7DMslU_fMwWxtrkYtFawGO0/preview' },
    { codigo: '3151', nombre: 'Estímulos a la Circulación local: Presentaciones de circo', url: 'https://drive.google.com/file/d/1Bdu1VEPTLyRenNSTHPaGe78VP8Yxjtcf/preview' },
    { codigo: '3144', nombre: 'Estímulos a la Circulación local: Presentaciones de circo', url: 'https://drive.google.com/file/d/1Bdu1VEPTLyRenNSTHPaGe78VP8Yxjtcf/preview' },
    { codigo: '3152', nombre: 'Estímulos a la Circulación local: Presentaciones de circo', url: 'https://drive.google.com/file/d/1Bdu1VEPTLyRenNSTHPaGe78VP8Yxjtcf/preview' },
    { codigo: '3145', nombre: 'Estímulos a la Circulación local: Presentaciones de circo', url: 'https://drive.google.com/file/d/1Bdu1VEPTLyRenNSTHPaGe78VP8Yxjtcf/preview' },
    { codigo: '3063', nombre: 'Estímulos a la Circulación local: Presentaciones de circo', url: 'https://drive.google.com/file/d/1Bdu1VEPTLyRenNSTHPaGe78VP8Yxjtcf/preview' },
    { codigo: '3149', nombre: 'Estímulos a la Circulación local: Presentaciones de circo', url: 'https://drive.google.com/file/d/1Bdu1VEPTLyRenNSTHPaGe78VP8Yxjtcf/preview' },
    { codigo: '3148', nombre: 'Estímulos a la Circulación local: Presentaciones de circo', url: 'https://drive.google.com/file/d/1Bdu1VEPTLyRenNSTHPaGe78VP8Yxjtcf/preview' },
    { codigo: '3147', nombre: 'Estímulos a la Circulación local: Presentaciones de circo', url: 'https://drive.google.com/file/d/1Bdu1VEPTLyRenNSTHPaGe78VP8Yxjtcf/preview' },
    { codigo: '3150', nombre: 'Estímulos a la Circulación local: Presentaciones de circo', url: 'https://drive.google.com/file/d/1Bdu1VEPTLyRenNSTHPaGe78VP8Yxjtcf/preview' },
    { codigo: '3146', nombre: 'Estímulos a la Circulación local: Presentaciones de circo', url: 'https://drive.google.com/file/d/1Bdu1VEPTLyRenNSTHPaGe78VP8Yxjtcf/preview' },
  ];

  const lep: any = [
    {
      title: "PULEP",
      render: (datos: any) => {
        return datos.codigo
      },
    },
    {
      title: "Nombre",
      render: (datos: any) => {
        return datos.nombre
      },
    },
    {
      title: "Otorgamiento",
      fixed: 'right',
      align: 'center' as 'center',
      render: (datos: any) => {
        return (
          <Button
            className="button-azul-ghost"
            style={{ cursor: 'pointer' }}
            onClick={() => {
              visualizarModal(datos.url);
            }}
          >
            <EyeIcon />
          </Button>
        );
      },
    }
  ];

  const [visualizar, setVisualizar] = useState<boolean>(false);
  const [visualizar2, setVisualizar2] = useState<boolean>(false);

  const mostrarModal2021 = () => {
    setVisualizar(true);
  }

  const mostrarModal2022 = () => {
    setVisualizar2(true);
  }

  const onCancel = () => {
    setVisualizar(false);
    setVisualizar2(false)
  }

  const onCancelUrl = () => {
    setUrl('')
    setVisualizarDocument(false)
  }

  return (
    <>
      <Header />
      <HeaderScc />
      <div className="container-fluid2">
        <div className="row">
          <br />
        </div>
        <div className="row">
          <div className="col-12 col-md-6 col-sm-6 text-center">
            <img src={lepRecursos} style={{maxWidth: '80%'}} alt="Recursos Ley de espectaculos publicos"></img>
            <div className="font-size-26px font-family-Montserrat text-center font-color-black">
              Si alguna vez te has preguntado cómo financiar un proyecto artístico, cómo mejorar el lugar donde presentas tus obras o cómo mover tu trabajo por otras ciudades o países… la LEP es para vos.
            </div>
          </div>
          <div className="col-12 col-md-6 col-sm-6 justify-content-center">
            <img src={lepHome} style={{maxWidth: '80%'}} alt="Ley de espectaculos publicos"></img>
          </div>
        </div>
        <CarouselLEP></CarouselLEP>
        <div className="row justify-content-center">
          <div className="col-12 col-md-6 col-sm-6 text-center">
            <Button
              type="link"
              className="button-azul-radius-detalle"
              style={{ fontSize: '14px', width: 'auto', display: 'inline-block', whiteSpace: 'nowrap' }}
              onClick={mostrarModal2021}
            >
              <span className="container-detalle-card-body-bold" style={{ fontSize: '14px' }}>Otorgamientos LEP 2021</span>
            </Button>
            <br />
          </div>
          <div className="col-12 col-md-6 col-sm-6 text-center">
            <Button
              type="link"
              className="button-azul-radius-detalle"
              style={{ fontSize: '14px', width: 'auto', display: 'inline-block', whiteSpace: 'nowrap' }}
              onClick={mostrarModal2022}
            >
              <span className="container-detalle-card-body-bold" style={{ fontSize: '14px' }}>Otorgamientos LEP 2022</span>
            </Button>
            <br />
          </div>
        </div>
      </div>
      <Footer />
      <Modal
        className="ant-modal-close-x2"
        maskStyle={{
          backgroundColor: "rgba(6, 100, 144 ,0.71)",
        }}
        visible={visualizasdocument}
        onCancel={onCancelUrl}
        width={1200}
        footer={[
          <Button key="B_CERRAR_1" className="button-gray-ghost m-0" onClick={onCancelUrl}>
            Cerrar
          </Button>,
        ]}
        cancelButtonProps={{ style: { display: "none" } }}
      >
        <div>
          <iframe src={url} style={{ width: '100%', height: '500px' }}></iframe>
        </div>
      </Modal>
      <Modal
        className="ant-modal-close-x2"

        title="Otorgamientos LEP 2021"
        maskStyle={{
          backgroundColor: "rgba(6, 100, 144 ,0.71)",
        }}
        visible={visualizar}
        onCancel={onCancel}
        width={1200}
        footer={[
          <Button key="B_CERRAR_1" className="button-gray-ghost m-0" onClick={onCancel}>
            Cerrar
          </Button>,
        ]}
        cancelButtonProps={{ style: { display: "none" } }}
      >
        <div>
          <br />
          <Table
            columns={lep}
            pagination={{ hideOnSinglePage: true }}
            dataSource={lep2021}
            className="tabla-information-anexos"
          />
        </div>
      </Modal>
      <Modal
        className="ant-modal-close-x2"

        title="Otorgamientos LEP 2022"
        maskStyle={{
          backgroundColor: "rgba(6, 100, 144 ,0.71)",
        }}
        visible={visualizar2}
        onCancel={onCancel}
        width={1200}
        footer={[
          <Button key="B_CERRAR_1" className="button-gray-ghost m-0" onClick={onCancel}>
            Cerrar
          </Button>,
        ]}
        cancelButtonProps={{ style: { display: "none" } }}
      >
        <div>
          <br />
          <Table
            columns={lep}
            pagination={{ hideOnSinglePage: true }}
            dataSource={lep2022}
            className="tabla-information-anexos"
          />
        </div>
      </Modal>
    </>
  );
};
